export const HOME_BREADCRUMB = {
  id: "home",
  text: "Home",
};
